export const SecurityUtils = {
  DEFAULT_MAX_LENGTH: 255,

  XSS_REGEX: /[<>"'%&;]/g,

  sanitize: (value: string, maxLength?: number): string => {
    if (!value) return '';

    const sanitized = value.replace(SecurityUtils.XSS_REGEX, '');

    if (maxLength && maxLength > 0) {
      return sanitized.slice(0, maxLength);
    }

    return sanitized;
  },

  sanitizeObject: (input: any, skipKeys: string[] = ['password']): any => {
    if (input === null || input === undefined) return input;

    if (typeof input === 'string') {
      return SecurityUtils.sanitize(input);
    }

    if (Array.isArray(input)) {
      return input.map((item) => SecurityUtils.sanitizeObject(item, skipKeys));
    }

    if (typeof input === 'object') {
      const sanitized: Record<string, any> = {};
      Object.keys(input).forEach((key) => {
        if (skipKeys.includes(key)) {
          sanitized[key] = input[key];
        } else {
          sanitized[key] = SecurityUtils.sanitizeObject(input[key], skipKeys);
        }
      });
      return sanitized;
    }

    return input;
  }
};